var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-more",style:(_vm.heightStyle)},[_c('div',{ref:"contents",staticClass:"contents"},[_vm._t("default")],2),(!_vm.isOpen)?_c('a',{on:{"click":_vm.open}},[_c('ArrowSvg'),_vm._v(_vm._s(_vm.moreText))],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }